<template>
  <v-layout row wrap>
    <v-flex xs12 class="py-3 mb-5">
      <v-container ma-0>
        <div class="white--text">
          <a href="https://movieseverywhere.net/" target="_blank">
            <img
              class="cursor-pointer"
              src="../../assets/communicada-color.png"
              height="80vh"
            />
          </a>

        </div>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import i18n from "@/i18n";
export default {
  name: "AppHeader",
  data: () => ({
    menus: [
      {
        text: i18n.t("screener.homepage.menu_1"),
        route: {
          name: "",
          params: {}
        }
      },
      {
        text: i18n.t("screener.homepage.menu_2"),
        route: {
          name: "",
          params: {}
        }
      },
      {
        text: i18n.t("screener.homepage.menu_3"),
        route: {
          name: "screeners.upcoming",
          params: {}
        }
      }
    ]
  })
};
</script>
